import apiProvider from './provider';
import {
  SHIPPING_SEARCH,
  EXECUTION_GET_TASK_SUMMARY,
  EXECUTION_GET_TASK_COUNT_BY_STATUS,
  EXECUTION_FETCH_D0_DETAILS,
  EXECUTION_UPDATE_SHIPMENT,
  EXECUTION_DELETE_SHIPMENT,
  EXECUTION_SEARCH_BOOKING_ID,
  EXECUTION_GET_SHIPMENT_FOR_BOOKING,
  EXECUTION_CREATE_DO,
  EXECUTION_EDIT_DO,
  EXECUTION_GET_FF_FOR_TASK,
  EXECUTION_FETCH_ALL_ACTIVITIES,
  EXECUTION_MIS_REPORTS,
  EXECUTION_GET_CONTAINER_LIST,
  EXECUTION_GET_BL_LIST,
  EXECUTION_ADD_TRACKING,
  EXECUTION_GET_CUSTOM_FIELDS,
  GET_PORTS,
  SEARCH_STAKEHOLDER,
  EXECUTION_FETCH_BOOKING_DETAILS,
  EXECUTION_GET_DOCUMENTS,
  EXECUTION_SHARE_DOCUMENTS,
  EXECUTION_GET_DOCUMENTS_MASTERS,
  EXECUTION_SAILING_SCHEDULES,
  EXECUTION_SELECTED_SCHEDULE,
  EXECUTION_BOOKING_NOTE_VESSEL_SCHEDULE,
  EXECUTION_BOOKING_NOTE_DETAILS,
  EXECUTION_TASK,
  EXECUTION_COMPUTE_DEADLINES,
  EXECUTION_NOTIFICATION,
  EXECUTION_NOTIFICATION_POLLING,
  EXECUTION_BULK_TASK,
  EXECUTION,
  EXECUTION_ACTIVITY,
  EXECUTION_GET_TASK_TEMPLATES,
  EXECUTION_FETCH_SHIPMENT_INSTRUCTIONS,
  EXECUTION_FETCH_SI_DRAFT_DETAILS,
  EXECUTION_SAVE_SI_DRAFT,
  EXECUTION_FETCH_SI_PACKAGE_TYPES,
  EXECUTION_FETCH_SI_CONTAINERS,
  EXECUTION_SI_FETCH_PARTIES_INVOLVED_ADDRESS,
  EXECUTION_SI_ADD_PARTIES_INVOLVED_ADDRESS,
  EXECUTION_SI_FETCH_CONTAINER_DETAILS,
  EXECUTION_SI_FETCH_PENDING_COUNT,
  EXECUTION_FETCH_SI_DETAILS,
  EXECUTION_SAVE_SHIPPING_INSTRUCTION,
  EXECUTION_DELETE_SI_REQUEST,
  EXECUTION_AMEND_SI_REQUEST,
  EXECUTION_RETRY_SI_REQUEST,
  EXECUTION_EDIT_SHIPMENT_WATCHER,
  EXECUTION_VGM_METHOD_REQUEST,
  EXECUTION_VGM_FETCH_AUTHORISED_PERSONS,
  EXECUTION_VGM,
  EXECUTION_VGM_SAVE_REQUEST,
  EXECUTION_VGM_SAVE_DRAFT_REQUEST,
  EXECUTION_VGM_FETCH_DRAFT,
  EXECUTION_VGM_GET_THIRD_PARTY_AUTH_LETTER,
  EXECUTION_VGM_ADD_THIRD_PARTY_AUTH_LETTER,
  EXECUTION_FETCH_VGM_REQUESTS,
  EXECUTION_FETCH_VGM_DETAILS,
  EXECUTION_FETCH_VGM_REQUEST_STATUS,
  EXECUTION_RETRY_VGM_REQUEST,
  EXECUTION_VGM_FETCH_USER_ASSIGNEE,
  EXECUTION_FORM_13,
  EXECUTION_FORM_13_REQUEST_ODEX_REF_NUMBER,
  EXECUTION_FORM_13_FETCH_VESSEL_MASTERS,
  EXECUTION_FORM_13_FETCH_POD_MASTERS,
  EXECUTION_FORM_13_FETCH_CFS,
  EXECUTION_FORM_13_FETCH_PENDING_CONTAINERS,
  EXECUTION_FORM_13_SAVE_DRAFT,
  EXECUTION_FORM_13_FETCH_REQUESTS,
  EXECUTION_FORM_13_FETCH_REQUEST,
  EXECUTION_FORM_13_FETCH_ORG_ASSIGNEE,
  EXECUTION_GET_EDIT_TASK_DETAILS,
  EXECUTION_DUPLICATE_TASK_DETAILS_FIELD,
  EXECUTION_DELETE_TASK_DETAILS_FIELD,
  EXECUTION_GET_DAILY_MIS_REPORT,
  EXECUTION_DOWNLOAD_DAILY_MIS_REPORT,
  COURIER_PARTNER,
  EXECUTION_GET_BOE_DETAILS,
  ENTRY_PORT,
  GET_EXECUTION_PORTS,
  GET_EXECUTION_DROPDOWN_MASTER,
  EXECUTION_GET_COURIER_TRACKING,
  GET_EXECUTION_CUSTOM_FIELD_DROPDOWN,
  EXECUTION_BULK_SHIPMENT,
  EXECUTION_DOWNLOAD_SAMPLE_FILE,
  GET_SHIPMENT_CONTAINERS,
  EXECUTION_DELINK_CONTAINERS,
  EXECUTION_GET_CARGO_LIST,
  BULK_UPDATE_DOWNLOAD_SAMPLE_FILE,
  FETCH_USER_FORM_FIRLD_CONFIG,
  FETCH_USER_FORM_FIRLD_MASTER,
  FETCH_MY_TASK_NAME_LIST,
  GET_SHIPMENT_PIC_DETAILS,
  UPDATE_SHIPMENT_PIC_DETAILS,
  SHIPMENT_TENDER_MANUAL,
  EXECUTION_GET_COURIER_V2_VENDORS,
  EXECUTION_GET_COURIER_V2_TRACKING,
  EXECUTION_POST_ADD_COURIER_V2,
  SE_LINK_BL_TO_CONTAINER,
} from './routes';
import { getAuthenticationHeaders, getErrorMessage, mockResponse, generateQueryString } from './utils';
import { API_BASE_URL } from 'src/globals';
import { GET, POST, UPDATE, PATCH, DELETE, ApiResponseWrapper } from './apiHandler';
import ApiDto from 'src/dto/ApiDto';
import { APIResponseType, CourierPartner } from 'src/Library/Types';
import masterDataProto from 'src/Library/MasterDataType';
import GetBookingDetailData from 'src/dto/response/getBookingDetail';
import { GetTaskDetailsData } from 'src/dto/response/getTaskDetails';
import { GetFieldsForDocumentTemplate } from 'src/dto/response/getFieldsForDocumentTemplate';
import { FetchShipmentTasksData } from 'src/dto/response/fetchShipmentTasks';
import { SEFFBid } from 'src/dto/response/fetchSEBids';
import { FetchActivityResponseType } from 'src/components/pages/shipment-execution/SE.Types';
import { SearchedVesselSchedules } from 'src/components/pages/VesselSchedules/VesselSchedules.types';
import GetExecutionData from 'src/dto/response/getExecution';
import { BidSearchResponseType, DocumentDetailsDto, QuoteSearchResponseType, SEPortType } from 'src/components/pages/shipment-execution/SE.interfaces';
import { AxiosResponse } from 'axios';
export const fetchAllShipment = (params /*: typeof ApiDto.FetchAllShipmentsV2Dto*/) => {
  return GET(`${API_BASE_URL}${EXECUTION}`, params);
};

export const searchShippingApi = async (params: typeof ApiDto.SearchShipmentDataDto, signal?: AbortSignal) => {
  return POST(`${API_BASE_URL}${EXECUTION}${SHIPPING_SEARCH}`, params, undefined, false, signal);
};

// TODO: GetTaskSummaryForShipmentDto  not available at the moment
export const getTaskSummaryForShipment = async (
  params /*: typeof ApiDto.GetTaskSummaryForShipmentDto*/
) => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_GET_TASK_SUMMARY}`, params);
};

export const getTaskCountByStatusForShipment = async (
  params /*: typeof ApiDto.GetTaskCountByStatusForShipmentDto*/
) => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_GET_TASK_COUNT_BY_STATUS}`, params);
};

export const fetchAllDeliveryOrderExecutions = async (
  shipmentId: string /*: typeof ApiDto.FetchAllDeliveryOrderExecutionsDto*/
) => {
  return GET(`${API_BASE_URL}${EXECUTION_FETCH_D0_DETAILS(shipmentId)}`);
};

export const createShipment = async (params: typeof ApiDto.CreateShipmentV2Dto) => {
  return POST(`${API_BASE_URL}${EXECUTION}`, params);
};

// TODO: 94ce40140acc46068146bdbf7b8d62b1
export const editShipment = async (params: any) => {
  return UPDATE(`${API_BASE_URL}${EXECUTION}/${params.shipmentId}`, params);
};

export const editShipmentWatcher = async (
  shipmentId: string,
  body: {
    watcherList: string[];
  }
): Promise<APIResponseType<null>> => {
  return PATCH(`${API_BASE_URL}${EXECUTION_EDIT_SHIPMENT_WATCHER(shipmentId)}`, body);
};

export const updateShipment = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${EXECUTION}${EXECUTION_UPDATE_SHIPMENT}`,
      body,
      {
        headers: getAuthenticationHeaders(),
      }
    );
    return {
      data: response,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getNotifications = async (params) => {
  return GET(`${API_BASE_URL}${EXECUTION_NOTIFICATION}`, params);
};

export const markNotifications = async (params) => {
  return PATCH(`${API_BASE_URL}${EXECUTION_NOTIFICATION}`, params);
};

export const getNotificationsPolling = async () => {
  return GET(`${API_BASE_URL}${EXECUTION_NOTIFICATION_POLLING}`);
};

export const getShipmentDetails = async (params /*: typeof ApiDto.GetShipmentDetailsV2Dto*/): Promise<APIResponseType<GetExecutionData>> => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<any>> = await apiProvider.get(
      `${API_BASE_URL}${EXECUTION}/${params.shipmentId}?viewType=${params.viewType}`,
      {
        headers: getAuthenticationHeaders(),
      }
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const searchBookingId = async (
  params: typeof ApiDto.SearchBookingForShipmentDto
): Promise<APIResponseType<{ id: string; bookingNumber: string }[]>> => {
  return POST(`${API_BASE_URL}${EXECUTION}${EXECUTION_SEARCH_BOOKING_ID}`, params);
};

export const getShipmentsForBooking = async (params) => {
  // TODO add dto type
  // params: typeof ApiDto.GetShipmentsForBookingDto
  // currently absent in swagger.ts
  try {
    const response: any = await apiProvider.get(
      `${API_BASE_URL}${EXECUTION}${EXECUTION_GET_SHIPMENT_FOR_BOOKING}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      }
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const createDO = async (
  shipmentId,
  body
) => {
  return POST(`${API_BASE_URL}${EXECUTION_CREATE_DO(shipmentId)}`, body);
};

export const editDO = async (
  shipmentId,
  dOExecutionId,
  body
) => {
  return PATCH(`${API_BASE_URL}${EXECUTION_EDIT_DO(shipmentId, dOExecutionId)}`, body);
};

export const fetchAllActivities = async (params, body)
  : Promise<APIResponseType<FetchActivityResponseType>> => {
  return POST(
    `${API_BASE_URL}${EXECUTION}/${params.id}${EXECUTION_ACTIVITY}${EXECUTION_FETCH_ALL_ACTIVITIES}`,
    body
  );
};

export const deleteShipment = async (body): Promise<APIResponseType<{
  failureArray: {
    id: string;
    reference_number: string;
    error_message: string;
    error: any;
  }[],
  successArray: {
    id: string;
  }[],
}>> => {
  return POST(`${API_BASE_URL}${EXECUTION}${EXECUTION_DELETE_SHIPMENT}`, body);
};

export const holdShipment = async (body) => {
  return POST(`${API_BASE_URL}${EXECUTION}/${body.shipmentId}/hold`, body);
};

export const releaseShipment = async (body) => {
  return POST(`${API_BASE_URL}${EXECUTION}/${body.shipmentId}/release`, body);
};

export const getTaskTypeForTask = async (params) => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_GET_TASK_TEMPLATES(params.shipmentId)}`);
};

export const getResponsibileOrgsForShipment = async (params) => {
  // TODO add dto type
  // params: typeof ApiDto.GetTaskResponsibleOrganisationMasterDto
  // currently absent in swagger.ts
  try {
    const response: any = await apiProvider.get(
      `${API_BASE_URL}${EXECUTION}${EXECUTION_GET_FF_FOR_TASK}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      }
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getExecutionMISReport = async () => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_MIS_REPORTS}`);
};

export const fetchAllContainersForShipment = (executionNumber: string) => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_GET_CONTAINER_LIST}/${executionNumber}`);
};

export const fetchAllBLsForShipment = (executionNumber: string) => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_GET_BL_LIST}/${executionNumber}`);
};

export const fetchAllCargosForShipment = (executionNumber: string) => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_GET_CARGO_LIST}/${executionNumber}`);
}

export const computeDeadlineDependentTasksV2 = (params, query) => {
  // TODO add dto type
  // (params: typeof ApiDto.ComputeDeadlineOfDependentTasksDto)
  // Backend issue. All fields are mandatory in dto.
  return GET(
    `${API_BASE_URL}${EXECUTION}/${params.shipmentId}${EXECUTION_COMPUTE_DEADLINES}`,
    query
  );
};

export const addTracking = (params) => {
  return POST(`${API_BASE_URL}${EXECUTION}${EXECUTION_ADD_TRACKING}`, params);
};

export const fetchSailingSchedules = (shipmentId): Promise<APIResponseType<any>> => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_SAILING_SCHEDULES(shipmentId)}`);
};

export const fetchSelectedSchedule = (shipmentId, taskId) => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_SELECTED_SCHEDULE(shipmentId, taskId)}`);
};

export const fetchBookingNoteVesselSchedules = (shipmentId, taskId) => {
  return GET(`${API_BASE_URL}${EXECUTION_BOOKING_NOTE_VESSEL_SCHEDULE(shipmentId, taskId)}`);
};

export const fetchBookingNoteDetails = (shipmentId, taskId) => {
  return GET(`${API_BASE_URL}${EXECUTION_BOOKING_NOTE_DETAILS(shipmentId, taskId)}`);
};

export const submitSelectedSchedule = (
  shipmentId: string,
  taskId: string,
  body: { vesselScheduleDetails: SearchedVesselSchedules | undefined; markDone: boolean }
) => {
  return PATCH(
    `${API_BASE_URL}${EXECUTION}${EXECUTION_SELECTED_SCHEDULE(shipmentId, taskId)}`,
    body
  );
};

export const getCustomFields = (params: {
  moduleName: keyof typeof masterDataProto.execution.moduleNamesForCustomFields;
  queryString?: string;
}): Promise<
  APIResponseType<
    {
      id: number;
      organisationId: string;
      name: string;
      description: string;
      isActive: boolean;
      moduleId: number;
      dbKey: string;
    }[]
  >
> => {
  return GET(`${API_BASE_URL}${EXECUTION_GET_CUSTOM_FIELDS}`, params);
};

export const getPorts = async (
  params: any = { queryString: ' ' }
): Promise<
  APIResponseType<
    {
      code: string;
      countryCode: string;
      countryName: string;
      name: string;
      type: SEPortType;
    }[]
  >
> => {
  return GET(`${API_BASE_URL}${GET_PORTS}`, params);
};

/** Get ports with mode filter */
export const getSEPorts = async (
  params: any = { queryString: '' }
): Promise<
  APIResponseType<
    {
      code: string;
      countryCode: string;
      countryName: string;
      name: string;
      type: SEPortType;
    }[]
  >
> => {
  return GET(`${API_BASE_URL}${GET_EXECUTION_PORTS(params.id)}`, params);
};

export const getSEGenericDropdownValues = async (params: {
  type: string;
  shipmentExecutionId: string;
  apiParams?: Record<string, string | undefined>;
}): Promise<
  APIResponseType<
    {
      label: string;
      key: string;
    }[]
  >
> => {
  const {
    apiParams = { fieldType: params.type }
  } = params;

  return GET(`${API_BASE_URL}${GET_EXECUTION_CUSTOM_FIELD_DROPDOWN(params.shipmentExecutionId)}`, apiParams);
};

export const getSEDropdownMasters = async (shipmentId: string): Promise<APIResponseType<any>> => {
  return GET(`${API_BASE_URL}${GET_EXECUTION_DROPDOWN_MASTER(shipmentId)}`);
};

export const searchCustomer = async (
  params = {
    type: 'CUSTOMER' as 'CUSTOMER' | 'SUPPLIER',
    queryString: '',
  }
): Promise<
  APIResponseType<
    {
      org2Id: string;
      name: string;
    }[]
  >
> => {
  return GET(`${API_BASE_URL}${SEARCH_STAKEHOLDER}`, params);
};

export const getBookingDetails = async (
  bookingId: string
): Promise<APIResponseType<GetBookingDetailData>> => {
  return GET(`${API_BASE_URL}${EXECUTION}${EXECUTION_FETCH_BOOKING_DETAILS}/${bookingId}`, {});
};

export const createShipmentTask = async (
  params: any,
  body
) => {
  return POST(`${API_BASE_URL}${EXECUTION}/${params.shipmentId}${EXECUTION_TASK}`, body);
};

export const editShipmentTask = async (params: any, body) => {
  return PATCH(
    `${API_BASE_URL}${EXECUTION}/${params.shipmentId}${EXECUTION_TASK}/${params.taskId}`,
    body
  );
};

export const fetchShipmentTasks = async (
  params
): Promise<APIResponseType<FetchShipmentTasksData>> => {
  return GET(`${API_BASE_URL}${EXECUTION}/${params.shipmentId}/task`);
};

export const addLinkedBlNumberToContainer =  async (params) => {
  return PATCH(
    `${API_BASE_URL}${SE_LINK_BL_TO_CONTAINER}`, params
  )
}

export const sendShipmentTenderEmail = async (params) => {
  return POST(`${API_BASE_URL}${SHIPMENT_TENDER_MANUAL}`, params);
};

export const fetchTaskSeqToDisable = async ({
  shipmentId,
}: {
  shipmentId: string;
}): Promise<
  APIResponseType<{
    current_sequence_number?: number;
  }>
> => {
  return GET(`${API_BASE_URL}${EXECUTION}/${shipmentId}/sequenceNumber`);
};

export const getTaskDetails = (
  { id, taskId, ...params } /*TODO: DTO */
): Promise<APIResponseType<GetTaskDetailsData>> => {
  // return mockResponse({ data: (window as any).mock });
  return GET(`${API_BASE_URL}${EXECUTION_GET_EDIT_TASK_DETAILS(id, taskId)}`, params);
};

export const updateTaskDetails = ({
  id,
  taskId,
  params,
}: {
  id: string;
  taskId: string;
  params: typeof ApiDto.UpdateTaskDetailsForShipmentDto;
}): Promise<APIResponseType<any>> => {
  return PATCH(`${API_BASE_URL}${EXECUTION_GET_EDIT_TASK_DETAILS(id, taskId)}`, params);
};

export const duplicateTaskDetailsField = ({
  id,
  taskId,
  fieldId,
  ...params
}): Promise<APIResponseType<any>> => {
  return POST(
    `${API_BASE_URL}${EXECUTION_DUPLICATE_TASK_DETAILS_FIELD(id, taskId, fieldId)}`,
    params
  );
};

export const deleteTaskDetailsField = ({
  id,
  taskId,
  fieldId,
  ...params
}): Promise<APIResponseType<any>> => {
  return DELETE(
    `${API_BASE_URL}${EXECUTION_DELETE_TASK_DETAILS_FIELD(id, taskId, fieldId)}`,
    params
  );
};

export const updateContainerDetails = (
  { id, taskId, ...params } /*TODO: DTO */
): Promise<APIResponseType<any>> => {
  return PATCH(`${API_BASE_URL}/execution/${id}/task/${taskId}/container-details`, params);
};

export const getDocumentTemplates = ({
  id,
  taskId,
  ...params
}): Promise<APIResponseType<{
    code: string;
    id: string;
    name: string;
    isMandatory?: boolean;
  }[]>> => {
  return GET(`${API_BASE_URL}/execution/${id}/task/${taskId}/document-templates`, params);
};

export const getFieldForDocumentTemplates = ({
  id,
  ...params
}: {
  id: string;
  documentTemplateId: number | string;
}): Promise<APIResponseType<GetFieldsForDocumentTemplate>> => {
  return GET(`${API_BASE_URL}/execution/${id}/field-details-for-document-template`, params);
};

export const updateTaskDocuments = ({
  id,
  taskId,
  params,
}: DocumentDetailsDto): Promise<
  APIResponseType<
    {
      id: string;
      name: string;
    }[]
  >
> => {
  return POST(`${API_BASE_URL}/execution/${id}/task/${taskId}/documents`, params);
};

export const deleteTaskDocuments = ({
  id,
  taskId,
  documentId,
  attachmentUrl,
}: {
  id: string;
  taskId: string;
  documentId: string;
  attachmentUrl: string;
}): Promise<APIResponseType<any>> => {
  return DELETE(`${API_BASE_URL}/execution/${id}/task/${taskId}/documents/${documentId}`, { attachmentUrl });
}

export const getDependentTaskStatuses = ({
  id,
  taskId,
  params,
}: {
  id: string;
  taskId: string;
  params: { newStatus: string };
}) => {
  return GET(`${API_BASE_URL}/execution/${id}/task/${taskId}/dependent-tasks/status`, params);
};

export const fetchDocumentsMasters = async (params) => {
  return GET(`${API_BASE_URL}${EXECUTION_GET_DOCUMENTS_MASTERS(params.id)}`);
};

export const fetchDocumentsApi = async (id, params) => {
  return GET(`${API_BASE_URL}${EXECUTION_GET_DOCUMENTS(id)}`, params);
};

export const shareDocuments = async (shipmentId, payload: typeof ApiDto.ShareDocumentMail) => {
  return POST(`${API_BASE_URL}${EXECUTION_SHARE_DOCUMENTS(shipmentId)}`, payload);
};

export const fetchShipmentInstructions = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_FETCH_SHIPMENT_INSTRUCTIONS}?shipmentId=${shipmentId}`);
};

export const fetchShipmentInstructionsDraftDetails = async (shipmentId, taskId) => {
  return GET(`${API_BASE_URL}${EXECUTION_FETCH_SI_DRAFT_DETAILS}/${shipmentId}/${taskId || ''}`);
};

export const saveShippingInstructionsDraft = async (shipmentId, taskId, draftId, body) => {
  const paramsArray = [{ key: 'taskId', val: taskId }, { key: 'draftId', val: draftId }];
  return POST(
    `${API_BASE_URL}${EXECUTION_SAVE_SI_DRAFT}/${shipmentId}?${generateQueryString(paramsArray)}`,
    body);
};

export const fetchShipmentInstructionsPackageTypes = async () => {
  return GET(`${API_BASE_URL}${EXECUTION_FETCH_SI_PACKAGE_TYPES}`);
};

export const addShipmentInstructionsPartiesAddress = async (id, body) => {
  return POST(`${API_BASE_URL}${EXECUTION_SI_ADD_PARTIES_INVOLVED_ADDRESS}${id ? `/${id}` : ''}`, body);
};

export const fetchShipmentInstructionsPartiesAddress = async (shipmentId?) => {
  return GET(`${API_BASE_URL}${EXECUTION_SI_FETCH_PARTIES_INVOLVED_ADDRESS}`, shipmentId);
};

export const fetchShipmentInstructionsContainers = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_SI_FETCH_CONTAINER_DETAILS}`, shipmentId);
};

export const fetchShipmentInstructionsPendingCount = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_SI_FETCH_PENDING_COUNT}`, shipmentId);
};

export const fetchShipmentInstructionsDetails = async (shipmentId, id, taskId?) => {
  return GET(`${API_BASE_URL}${EXECUTION_FETCH_SI_DETAILS}/${shipmentId}/${taskId || ''}${id}`);
};

export const addShipmentInstruction = async (shipmentId, taskId, draftId, body) => {
  const paramsArray = [{ key: 'taskId', val: taskId }, { key: 'draftId', val: draftId }];
  return POST(`${API_BASE_URL}${EXECUTION_SAVE_SHIPPING_INSTRUCTION}/${shipmentId}?${generateQueryString(paramsArray)}`,
  body);
};

export const deleteSIRequest = async (shipmentId) => {
  return DELETE(`${API_BASE_URL}${EXECUTION_DELETE_SI_REQUEST}/${shipmentId}`);
};

export const amendShippingInstructions = async (shipmentId, draftId, body) => {
  const paramsArray = [{ key: 'id', val: draftId }];
  return POST(
    `${API_BASE_URL}${EXECUTION_AMEND_SI_REQUEST}/${shipmentId}?${generateQueryString(paramsArray)}`,
    body);
};

export const retryShippingInstructions = async (shipmentId, id, body) => {
  const paramsArray = [{ key: 'id', val: id }];
  return POST(
    `${API_BASE_URL}${EXECUTION_RETRY_SI_REQUEST}/${shipmentId}?${generateQueryString(paramsArray)}`, body);
}

export const getExecutionMilestoneCount = async (params) => {
  return GET(`${API_BASE_URL}/execution/milestone/count`, params);
};
export const approveTask = ({ id, taskId }: { id: string; taskId: string }) => {
  return PATCH(`${API_BASE_URL}/execution/${id}/task/${taskId}/approve`, {});
};

export const rejectTask = ({
  id,
  taskId,
  rejectionReason,
  rejectionDocumentUrl
}: {
  id: string;
  taskId: string;
  rejectionReason: string;
  rejectionDocumentUrl: string;
  navigateToSEListPage?: boolean;
}) => {
  return PATCH(`${API_BASE_URL}/execution/${id}/task/${taskId}/reject`, {
    rejectionReason,
    rejectionDocumentUrl
  });
};

export const fetchBids = ({
  id,
  ...params
}: {
  id: string;
}): Promise<APIResponseType<BidSearchResponseType>> => {
  return GET(`${API_BASE_URL}/execution/${id}/bids-search`, params);
};

/** Quotes Selection (GPO) — fetches quotes for a single vendor type. One call per tab. */
export const fetchQuotes = ({
  id,
  ...params
}: {
  id: string;
  vendorType: string;
}): Promise<APIResponseType<QuoteSearchResponseType>> => {
  return GET(`${API_BASE_URL}/execution/${id}/quote-search`, params);
};

export const fetchBidDetails = ({
  id,
  bidId,
  ...params
}: {
  id: string;
  bidId: string;
}): Promise<APIResponseType<any>> => {
  return GET(`${API_BASE_URL}/execution/${id}/bids/${bidId}`, params);
};

export const selectBid = ({
  id,
  taskId,
  ...params
}: {
  id: string;
  taskId: string;
} & /*typeof ApiDto.SelectBidForSE*/ any): Promise<APIResponseType<any>> => {
  return POST(`${API_BASE_URL}/execution/${id}/tasks/${taskId}/select-bid`, params);
};

export const fetchSelectedBids = ({
  id,
  taskId,
  ...params
}: {
  id: string;
  taskId: string;
}): Promise<
  APIResponseType<{
    bidSelectionReason?: string;
    rejectionReason?: string;
    details: SEFFBid;
    deviationFromL1?: number;
  }>
> => {
  return GET(`${API_BASE_URL}/execution/${id}/tasks/${taskId}/bid-details`, params);
};

export const fetchDailyMisReports = async (params) => {
  return GET(`${API_BASE_URL}${EXECUTION_GET_DAILY_MIS_REPORT}`, params);
};

export const downloadDailyMisReports = async (params) => {
  return GET(`${API_BASE_URL}${EXECUTION_DOWNLOAD_DAILY_MIS_REPORT}`, params, 'blob');
};

export const requestVGMMethod = async () => {
  return POST(`${API_BASE_URL}${EXECUTION_VGM}${EXECUTION_VGM_METHOD_REQUEST}`, '');
};

export const fetchVGMPendingContainers = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_VGM}/${shipmentId}/pending-containers`);
};

export const fetchVGMAuthorisedPersons = async (queryString) => {
  return GET(`${API_BASE_URL}${EXECUTION_VGM}${EXECUTION_VGM_FETCH_AUTHORISED_PERSONS}?name=${queryString}`);
};

export const saveVgmRequest = async (shipmentId, draftId, body) => {
  return POST(
    `${API_BASE_URL}${EXECUTION_VGM}/${shipmentId}${EXECUTION_VGM_SAVE_REQUEST}${draftId ? `/${draftId}` : ''}`,
    body);
};

export const saveVgmDraftRequest = async (shipmentId, draftId, body) => {
  return POST(
    `${API_BASE_URL}${EXECUTION_VGM}/${shipmentId}${EXECUTION_VGM_SAVE_DRAFT_REQUEST}${draftId ? `/${draftId}` : ''}`,
    body);
};

export const fetchVGMDraft = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_VGM}/${shipmentId}${EXECUTION_VGM_FETCH_DRAFT}`);
};

export const fetchVGMThirdPartyAuthLetter = async (shipperId) => {
  return GET(`${API_BASE_URL}${EXECUTION_VGM}${EXECUTION_VGM_GET_THIRD_PARTY_AUTH_LETTER}/${shipperId}`);
};

export const addVGMThirdPartyAuthLetter = async (body) => {
  return POST(`${API_BASE_URL}${EXECUTION_VGM}${EXECUTION_VGM_ADD_THIRD_PARTY_AUTH_LETTER}`, body);
};

export const fetchVGMRequests = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_VGM}/${shipmentId}${EXECUTION_FETCH_VGM_REQUESTS}`);
};

export const fetchVGMDetails = async (id) => {
  return GET(`${API_BASE_URL}${EXECUTION_VGM}${EXECUTION_FETCH_VGM_DETAILS}/${id}`);
};

export const deleteVGMRequest = async (draftId) => {
  return DELETE(`${API_BASE_URL}${EXECUTION_VGM}/${draftId}`);
};

export const fetchVGMRequestStatus = async (body, id) => {
  return POST(`${API_BASE_URL}${EXECUTION_VGM}/${id}${EXECUTION_FETCH_VGM_REQUEST_STATUS}`, body);
};

export const retryVgmRequest = async (shipmentId, id, body) => {
  return POST(
    `${API_BASE_URL}${EXECUTION_VGM}/${shipmentId}/${id}${EXECUTION_RETRY_VGM_REQUEST}`,
    body);
};

export const fetchVGMUserAssignee = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_VGM}/${shipmentId}${EXECUTION_VGM_FETCH_USER_ASSIGNEE}`);
};

export const form13RequestOdexRefNumber = async () => {
  return POST(`${API_BASE_URL}${EXECUTION_FORM_13}${EXECUTION_FORM_13_REQUEST_ODEX_REF_NUMBER}`, '');
};

export const form13FetchVesselMasters = async (carrierId, polId) => {
  const paramsArray = [
    { key: 'carrierId', val: carrierId },
    { key: 'polId', val: polId },
  ];
  return GET(`${API_BASE_URL}${EXECUTION_FORM_13}${EXECUTION_FORM_13_FETCH_VESSEL_MASTERS}?${generateQueryString(paramsArray)}`);
};

export const form13FetchPODMasters = async (polId, serviceName, terminalCode) => {
  const paramsArray = [
    { key: 'polId', val: polId },
    { key: 'serviceName', val: serviceName },
    { key: 'terminalCode', val: terminalCode },
  ];
  return GET(`${API_BASE_URL}${EXECUTION_FORM_13}${EXECUTION_FORM_13_FETCH_POD_MASTERS}?${generateQueryString(paramsArray)}`);
};

export const form13FetchCFS = async (queryString) => {
  return GET(`${API_BASE_URL}${EXECUTION_FORM_13}${EXECUTION_FORM_13_FETCH_CFS}?queryString=${queryString}`);
};

export const form13FetchPendingContainers = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_FORM_13}/${shipmentId}${EXECUTION_FORM_13_FETCH_PENDING_CONTAINERS}`);
};

export const form13SaveDraft = async (shipmentId, draftId, body) => {
  return POST(`${API_BASE_URL}${EXECUTION_FORM_13}/${shipmentId}${EXECUTION_FORM_13_SAVE_DRAFT}${draftId ? `/${draftId}` : ''}`,
  body);
};

export const fetchAllForm13Requests = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_FORM_13}/${shipmentId}${EXECUTION_FORM_13_FETCH_REQUESTS}`);
};

export const fetchForm13Request = async (id) => {
  return GET(`${API_BASE_URL}${EXECUTION_FORM_13}${EXECUTION_FORM_13_FETCH_REQUEST}/${id}`);
};

export const fetchForm13Draft = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_FORM_13}/${shipmentId}${EXECUTION_VGM_FETCH_DRAFT}`);
};

export const form13SaveRequest = async (shipmentId, draftId, body) => {
  return POST(
    `${API_BASE_URL}${EXECUTION_FORM_13}/${shipmentId}${EXECUTION_VGM_SAVE_REQUEST}${draftId ? `/${draftId}` : ''}`,
    body);
};

export const fetchForm13RequestStatus = async (body, id) => {
  return POST(`${API_BASE_URL}${EXECUTION_FORM_13}/${id}${EXECUTION_FETCH_VGM_REQUEST_STATUS}`, body);
};

export const retryForm13Request = async (shipmentId, id, body) => {
  return POST(
    `${API_BASE_URL}${EXECUTION_FORM_13}/${shipmentId}/${id}${EXECUTION_RETRY_VGM_REQUEST}`,
    body);
};

export const deleteForm13Request = async (draftId) => {
  return DELETE(`${API_BASE_URL}${EXECUTION_FORM_13}/${draftId}`);
};

export const fetchForm13OrgAssignee = async (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION_FORM_13}/${shipmentId}${EXECUTION_FORM_13_FETCH_ORG_ASSIGNEE}`);
};

export const getCourierPartners = async (): Promise<APIResponseType<CourierPartner[]>> => {
  return GET(`${API_BASE_URL}${COURIER_PARTNER}`);
};

export const getCourierTracking = (id: string) => {
  return GET(`${API_BASE_URL}${EXECUTION_GET_COURIER_TRACKING(id)}`);
};
export const getBoeDetails = (id) => {
  return GET(`${API_BASE_URL}${EXECUTION_GET_BOE_DETAILS(id)}`);
};

export const getEntryPorts = (): Promise<
  APIResponseType<
    {
      id: string;
      code: string;
      displayName: string;
      name: string;
    }[]
  >
> => {
  return GET(`${API_BASE_URL}${ENTRY_PORT}`);
};

export const postSEBulkShipmentUpload = async (body) => {
  return POST(`${API_BASE_URL}${EXECUTION_BULK_SHIPMENT}`,body);
};

export const downloadSEBulkShipmentSample = () => {
  return GET(`${API_BASE_URL}${EXECUTION_DOWNLOAD_SAMPLE_FILE}`, {}, 'blob');
};

export const getShipmentContainers = (
  referenceNumber: string
): Promise<APIResponseType<{ containerNumber: string; id: string }[]>> => {
  return GET(`${API_BASE_URL}${GET_SHIPMENT_CONTAINERS(referenceNumber)}`);
};

export const delinkContainers = (body: {
  containers: { containerNumber: string; containerId: string }[];
  shipmentIdToLink: string;
}): Promise<APIResponseType<null>> => {
  return POST(`${API_BASE_URL}${EXECUTION_DELINK_CONTAINERS}`, body);
};

export const downloadBulkUpdateShipmentShampleExcel = (params: {[key: string]: any}) => {
  return GET(`${API_BASE_URL}${BULK_UPDATE_DOWNLOAD_SAMPLE_FILE}`, params, 'blob')
};

export const postBulkUpdateShipment = (body: { awsUrl: string; fileName: string }) => {
  return POST(`${API_BASE_URL}${BULK_UPDATE_DOWNLOAD_SAMPLE_FILE}`, body);
};

export const getNewShipmentFormConfig = (params: {[key: string]: any}) => {
  return POST(`${API_BASE_URL}${FETCH_USER_FORM_FIRLD_CONFIG}`, params)
};

export const getNewShipmentFormConfigMaster = (params: {[key: string]: any}) => {
  return GET(`${API_BASE_URL}${FETCH_USER_FORM_FIRLD_MASTER}`, params)
};

export const searchMyTaskNameList = () => {
  return GET(`${API_BASE_URL}${FETCH_MY_TASK_NAME_LIST}`)
};

export const getShipmentPicDetails =  (shipmentId) => {
  return GET(`${API_BASE_URL}${EXECUTION}${GET_SHIPMENT_PIC_DETAILS(shipmentId)}`);
};

export const updateShipmentPicDetails = (params) => {
  return PATCH(`${API_BASE_URL}${EXECUTION}${UPDATE_SHIPMENT_PIC_DETAILS}`, params);
}

export const getElegibleCouriersPartners = async () => {
  return GET(`${API_BASE_URL}${EXECUTION_GET_COURIER_V2_VENDORS()}`);
}

export const fetchCouriersOfShipment = async (id: string) => {
  return GET(`${API_BASE_URL}${EXECUTION_GET_COURIER_V2_TRACKING(id)}`);
}

export const addNewCourierPartner = async (body) => {
  return POST(`${API_BASE_URL}${EXECUTION_POST_ADD_COURIER_V2()}`, body);
}